import script from "./StepPayment.vue?vue&type=script&setup=true&lang=ts"
export * from "./StepPayment.vue?vue&type=script&setup=true&lang=ts"

import "./StepPayment.vue?vue&type=style&index=0&id=374a393a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-374a393a"]])

export default __exports__